//import { appInsights } from '../appInsights.js';
//import { SeverityLevel } from '@microsoft/applicationinsights-web';
import jsonConstants from '../constants/jsonConstants';
import settings from '../constants/jsonXMLsettings';
import { RelyingPartyReference } from './policyXMLGeneration';
import { BuildSettings, extractSettingFieldValue } from './utils';

const uploadSinglePolicyFile = async (
  fileXML: string,
  fileId: string,
  targetEnvName: string,
) => {
  let uri = `${settings.policyUploadUri}`;
  let req = {
    env: targetEnvName,
    appObjectId: "",
    policies: [
      btoa(fileXML)
    ]
  };
  let resp = await fetch(uri, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(req),
  });

  if (!resp.ok) {
    let errMsg = await resp.text();
    console.log(`Upload failed for policy ${fileId}: ${errMsg}`);
  } else {
    console.log(`Uploaded policy ${fileId}`);
  }

  return resp.ok;
};

export const uploadPolicyToRemote = async (
  policyXml: string,
  policyId: string,
  rpFiles: RelyingPartyReference[],
  sessionId: string,
  json: {[index: string]: any},
  deploymentEnv: string,
) => {
  let targetEnvName = json.templatization.environments[deploymentEnv].name;
  
  let success = await uploadSinglePolicyFile(policyXml, policyId, targetEnvName);
  let uploaded = [];
  if (success) {
    uploaded.push(policyId);
  }
  for (const rpFile of rpFiles) {
    let result = await uploadSinglePolicyFile(rpFile.xml, rpFile.policyName, targetEnvName);
    if (result) {
      uploaded.push(rpFile.policyName);
    }
    success = success && result;
  }
  return { success, uploadedNames: uploaded };
};

export const deleteSinglePolicyFromRemote = async (policyId: string, tenantName: string) => {
  let uri = `${settings.policyDeleteUri}${policyId}&tenanttoupdate=${encodeURIComponent(tenantName).replaceAll("'",'%27')}`;
  let resp = await fetch(uri, {
    method: 'DELETE',
  });
  let successful = resp.ok;
  if (successful) {
    console.log(`Deleted policy ${policyId}`);
  } else {
    let errMsg = await resp.text();
    console.log(`Policy deletion failed for policy ${policyId}: ${errMsg}`);
  }
  return successful;
};

export const deleteMultiplePolicies = async (policyIds: string[], tenantName: string) => {
  let success = true;
  let deleted: string[] = [];
  for (let i = 0; i < policyIds.length; i++) {
    let result = await deleteSinglePolicyFromRemote(policyIds[i], tenantName);
    if (result) {
      deleted.push(policyIds[i]);
    }
    success = success && result;
  }
  return { success, deletedNames: deleted };
};

export const getRunNowLink = (rpFileName: string, buildSettings: BuildSettings, isSaml?: boolean) => {
  if (isSaml) {
    return settings.runNowSamlDeploymentUri;
  } else {
    return `https://${extractSettingFieldValue('tenantName', buildSettings)}.b2clogin.com/${extractSettingFieldValue('tenantName', buildSettings)}.onmicrosoft.com/oauth2/v2.0/authorize?p=${rpFileName}&client_id=${extractSettingFieldValue('oidcTestApplicationId', buildSettings)}&nonce=defaultNonce&redirect_uri=https%3A%2F%2Fjwt.ms&scope=openid&response_type=id_token&prompt=login`;
  }
};

// Limit for an Application Insights trace message is not high enough to send an entire XML policy in one log.
/*export const sendChunkedAIDataTrace = (message: string, properties: { [index: string]: string }) => {
  let index = 0;
  let chunkCount = 0;
  while (message.length - index > settings.aiTraceChunkSize) {
    properties['chunkId'] = chunkCount.toString();
    appInsights.trackTrace({
      message: message.substring(index, index + settings.aiTraceChunkSize),
      severityLevel: SeverityLevel.Information,
      properties: properties,
    });
    chunkCount += 1;
    index += settings.aiTraceChunkSize;
  }
  properties['chunkId'] = chunkCount.toString();
  appInsights.trackTrace({
    message: message.substring(index, index + settings.aiTraceChunkSize),
    severityLevel: SeverityLevel.Information,
    properties: properties,
  });
};*/
